import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { RouterSegments } from 'src/app/models/router-segments';
import { Capability, CapabilityType } from 'src/app/models/service/capability';
import { Solution } from 'src/app/models/service/solution';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { combineLatest, tap } from 'rxjs';
import { SolutionDetails } from 'src/app/models/service/solution-details';
import { ErrorPageService } from 'src/app/services/util/error-page.service';
import { AdditionalCapabilityComponent } from 'src/app/components/additional-capability/additional-capability.component';
import { ComponentType } from 'src/app/models/service/component-type';
import { Constants } from 'src/app/models/constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-choose-capability',
    templateUrl: './choose-capability.component.html',
    styleUrls: ['./choose-capability.component.scss'],
    standalone: false
})
export class ChooseCapabilityComponent  implements OnInit {
  private destroyRef = inject(DestroyRef);

  RouterSegments = RouterSegments;
  Constants = Constants;
  tenantId: string;
  breadcrumbItems: BreadcrumbItem[];
  solution: Solution;
  latestSolutionVersion: any;
  includedCapabilities: any;
  optionalCapabilities: any;
  selectedCapability = [];
  isLoading = true;
  blueprintId: any;
  blueprintData: any;
  service: any;
  capabilities: any;
  servicesVersionsMap: any;
  titleService: any;
  dataLoaded: boolean;
  UpdateExtendService: boolean;
  UpdateExtendServiceDisable: boolean;
  selectedCapabilitiesArr: any;
  selectedCapabilities: any;
  sortedSolutionVersionId: any;
  mainArray: any;
  additionalIncluded = [];
  additionalOptional = [];
  showLoader = false;
  capabilitiesPage = true;
  exchangeAdapters: any;
  selectedExchangeAdapters = [];
  additionalExchangeAdapters = [];
  previousSelection = JSON.parse(localStorage.getItem('selectedCapabilities'));
  getSelectedVersions = JSON.parse(localStorage.getItem('selectedVersion'));
  removeExchangeTab = false;
  versionData = [];
  versionsList = [];
  searchValue: any;
  solutionVersionForm: FormGroup;
  versionSelected = false;
  selectedVersion: any;
  selectedBuildVersion: any;
  isVersionAvailable = true;
    
  constructor(private solutionsService: SolutionsService, public authService: AuthService, private sidenavService: SidenavService,
    private activatedRoute: ActivatedRoute, private toastrService: CustomToastrService, private router: Router,
    private dialog: MatDialog, private blueprintsService: BlueprintsService, private errorPageService: ErrorPageService,
    private formBuilder: FormBuilder) {
    
  }

  //Initializes the component, Sets up the form, Loads solution versions and service data.
  ngOnInit(): void {

    const formConfig: any = {
      buildVersion: [undefined, [Validators.required]],
      searchValue: [''],
    };
    this.solutionVersionForm = this.formBuilder.group(formConfig);
    
    if (history.state.data === ComponentType.EXCHANGE) {
      this.capabilitiesPage = false;
    }
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.SERVICE_DEFINITION';
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    const serviceId = this.activatedRoute.snapshot.params.solutionId;
    this.solutionsService.getSolutionVersions(serviceId).subscribe(data => {

    if (data) {
      data.forEach(element => {
        this.versionData.push(element);
      });

      let versions = [];
      let arr = [];
      data.forEach(element => {
        arr.push(element.version);
      });
       arr = arr.map( a => a.split('.').map( n => +n+100000 ).join('.') ).sort()
        .map( a => { const parts = a.split('.').map( n => +n-100000)
        const major = parts[0];
        const minor = parts[1] ? parts[1].toString().padStart(2, '0') : '00';
        const patch = parts[2] ? parts[2].toString().padStart(2, '0') : '00';
        return `${major}.${minor}.${patch}`;
      });
      arr?.forEach(item => {
        this.versionData.forEach(data => {
          const major = data.version?.split('.')[0];
          const minor = data.version?.split('.')[1] ? data.version.split('.')[1]?.toString().padStart(2, '0') : '00';
          const patch = data.version?.split('.')[2] ? data.version.split('.')[2]?.toString().padStart(2, '0') : '00';
          data.patchVersion = major + '.' + minor + '.' + patch;
          if(data.patchVersion === item) {
          versions = [...versions, data];
        }})
      })
      this.versionData = this.versionData.map(item => item);

      if (data?.status === 'update_failed') {
        versions.push(data);
      }
      if (versions?.length) {
        this.versionGroup(versions);
      }
    }
    if(this.versionData.length === 0) {
      const noRelease = 'Release not Available';
      this.isVersionAvailable = false;
      this.versionData.push(noRelease);
    }
    
      this.sortedSolutionVersionId = (data.sort((a,b) => a?.version && b?.version ? b?.version?.localeCompare(a?.version) : !b?.version ? -1 : 1));
      this.getSolutionById(this.activatedRoute.snapshot.params.solutionId);
    })
    combineLatest([this.solutionsService.getSolutionDetailsById(serviceId),
      this.solutionsService.getSolutionVersions(serviceId)
    ])
      .pipe(
        tap(([service, serviceVersions]) => {
          const findVersion =  serviceVersions.find(item => item.id === service.latestSolutionVersionId);
          // this.loadCapabilitiesDescription(serviceId, service.latestSolutionVersionId);
          this.service = service;
          this.capabilities = findVersion.capabilities;
          if (this.capabilities?.length > 0) {
            this.capabilities.reduce((acc, capability) => {
              if (capability.required !== CapabilityType.OPTIONAL) {
                capability.selected = true;
              }
              return acc;
            }, {});
          }
          this.servicesVersionsMap.set(this.service.id, serviceVersions);
          this.configureBreadcrumb(service);
          this.titleService.setTitle(this.service?.name);
          // this.loadBlueprint();
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.dataLoaded = true;
      }, error => {
        // this.errorPageService.show404Page();
      });
    this.breadcrumbItems = [];
    this.breadcrumbItems.push({label: translate('TENANT_LAYOUT.MENU.SERVICE_DEFINITION'), url:[RouterSegments.TENANT, this.tenantId, RouterSegments.SERVICE_DEFINITION]},
    {label: translate('TENANT_LAYOUT.MENU.SOLUTIONS'), url:[RouterSegments.TENANT, this.tenantId, RouterSegments.SERVICE_DEFINITION, RouterSegments.SOLUTION]});
    this.getSolutionById(this.activatedRoute.snapshot.params.solutionId);
  }
  configureBreadcrumb(service: SolutionDetails) {
    throw new Error('Method not implemented.');
  }

  // Fetches the getSolutionById API from solutionsService
  getSolutionById(solutionId): void {
    this.solutionsService.getSolutionById(solutionId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(result => {
      this.isLoading = false;
      this.solution = result;
      if (this.getSelectedVersions) {
        this.getSelectedVersion(this.getSelectedVersions);
        this.selectedBuildVersion = this.getSelectedVersions;
        const version = this.versionData?.find(item =>item.version === this.getSelectedVersions.version);
        this.solutionVersionForm.get('buildVersion').setValue(version);
      }
   },
    (error) => {
      this.isLoading = false;
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  // Loads the latest solution version capabilities.
  getLatestSolutionVersion(solutionId, latestSolutionVersionId): void {
    this.showLoader = true;
    if (latestSolutionVersionId) {
      this.solutionsService.getSolutionVersion(solutionId, latestSolutionVersionId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((version: any) => {
        this.showLoader = false;
        this.isLoading = false;
        this.latestSolutionVersion = version;
        this.mainArray = this.latestSolutionVersion.capabilities;
        let additionalCapabilties = [];
        this.previousSelection?.forEach(item => {
          if (item.nestedObj) {
            const additional = item?.nestedObj?.filter(data => data.selected === true);
            additionalCapabilties = [...additionalCapabilties, ...additional];
          }
        });
        additionalCapabilties.forEach(item => {
          if (!this.previousSelection?.find(element => (element.name === item.name) && (item.selected === true))) {
            this.previousSelection = [...this.previousSelection, item];
          }
        })
        this.mainArray.forEach(item => {
          if (this.previousSelection?.find(element => element.name === item.name)) {
            item.selected = true;
            if (item.nested) {
              item.showAdditional = true;
            }
          }
        })
        this.latestSolutionVersion?.capabilities?.forEach(element => {
          if(element?.nested) {
            element.hasNested = true;
            element?.nested.forEach(data => {
              this.mainArray = this.mainArray.filter(item => item?.name !== data);
            });
          }
        });
        this.mainArray.forEach(element => {
          let nestedObj = [];
          let obj = {};
          if(element?.nested) {
            element?.nested.forEach(innerElement=> {
              if (this.latestSolutionVersion?.capabilities?.find(item => item.name === innerElement)) {
                obj = this.latestSolutionVersion?.capabilities?.find(item => item.name === innerElement);
              } else {
                obj = {
                  name: innerElement
                }
              }
              nestedObj = [...nestedObj, obj];
            });
            element.nestedObj = nestedObj;
            element.selectedNestedObj = element.nestedObj.filter(item => item.selected);
          }
        });
        const mainArray = this.mainArray;
        if (this.mainArray?.find(item => item.componentType)) {
          this.exchangeAdapters = mainArray.filter(item => item.componentType === ComponentType.EXCHANGE) || [];
          this.mainArray = mainArray.filter(item => item.componentType === ComponentType.TBC || item.componentType === ComponentType.TC);
        } else {
          this.exchangeAdapters = mainArray.filter(item => item.componentType === ComponentType.EXCHANGE) || [];
        }
        if (this.exchangeAdapters?.length === 0) {
          this.removeExchangeTab = true;
          this.capabilitiesPage = true;
        } else {
          this.removeExchangeTab = false;
        }
        this.includedCapabilities = this.mainArray?.filter(item => item?.required === CapabilityType.MANDATORY);
        this.optionalCapabilities = this.mainArray?.filter(item => item?.required === CapabilityType.OPTIONAL);
        if (!this.mainArray || this.mainArray?.length === 0) {
          this.includedCapabilities = [];
          this.optionalCapabilities = [];
        }
        this.additionalIncluded = [];
        this.additionalOptional = [];
        this.additionalExchangeAdapters = [];
        this.includedCapabilities.forEach(capab => {
          const selected = capab?.nestedObj?.filter(item => item?.selected === true) || [];
          this.additionalIncluded = [...this.additionalIncluded, ...selected];
        })
        this.selectedCapability = this.optionalCapabilities?.filter(item => item?.selected === true);
        this.selectedCapability.forEach(capab => {
          const selected = capab?.nestedObj?.filter(item => item?.selected === true) || [];
          this.additionalOptional = [...this.additionalOptional, ...selected];
        })
        this.selectedExchangeAdapters = this.exchangeAdapters?.filter(item => item?.selected === true);
        this.selectedExchangeAdapters.forEach(capab => {
          const selected = capab?.nestedObj?.filter(item => item?.selected === true) || [];
          this.additionalExchangeAdapters = [...this.additionalExchangeAdapters, ...selected];
        })
      },
      (error) => {
        this.isLoading = false;
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
    } else {
      this.isLoading = false;
      this.includedCapabilities = [];
      this.optionalCapabilities = [];
    }
  }

  // Opens dialog to submit 
  onClick(component) : void {
    this.dialog.open(AdditionalCapabilityComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: component.displayName ? component.displayName : component.name,
        component: component,
        confirmButtonText: translate('BUTTONS.SUBMIT')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result) {
          if (result.componentType === ComponentType.EXCHANGE) {
            const index = this.exchangeAdapters.findIndex(item => item.name === result.name);
            this.exchangeAdapters[index] = result;
            result?.nestedObj?.forEach(item => {
              this.additionalExchangeAdapters = this.additionalExchangeAdapters.filter(data => data.name !== item.name)
              })
            const selected = result?.nestedObj?.filter(item => item?.selected === true);
            this.additionalExchangeAdapters = [...this.additionalExchangeAdapters, ...selected];
            result.selectedNestedObj = result.nestedObj.filter(item => item.selected);
          } else if (result.required === CapabilityType.MANDATORY) {
            const index = this.includedCapabilities.findIndex(item => item.name === result.name);
            this.includedCapabilities[index] = result;
            result?.nestedObj?.forEach(item => {
              this.additionalIncluded = this.additionalIncluded.filter(data => data.name !== item.name)
              })
            const selected = result?.nestedObj?.filter(item => item?.selected === true);
            this.additionalIncluded = [...this.additionalIncluded, ...selected];
            result.selectedNestedObj = result.nestedObj.filter(item => item.selected);
          } else if(result.required === CapabilityType.OPTIONAL) {
            const index = this.optionalCapabilities.findIndex(item => item.name === result.name);
            this.optionalCapabilities[index] = result;
            result?.nestedObj?.forEach(item => {
              this.additionalOptional = this.additionalOptional.filter(data => data.name !== item.name)
              })
            const selected = result?.nestedObj?.filter(item => item?.selected === true);
            this.additionalOptional = [...this.additionalOptional, ...selected];
            result.selectedNestedObj = result.nestedObj.filter(item => item.selected);
          }
          this.selectedCapability = this.optionalCapabilities?.filter(item => item?.selected === true);
          this.selectedExchangeAdapters = this.exchangeAdapters?.filter(item => item?.selected === true);
        }
      });
  }

  // Toggles selection state for an optional capability.
  selectCapability(capability): void {
    this.optionalCapabilities.find(item => item?.name === capability?.name).selected = !capability.selected;
    this.optionalCapabilities?.forEach(item => {
      if(item?.name === capability?.name && item?.selected === true) {
        item.showAdditional = true;
      } else if(item?.name === capability?.name && item?.selected === false) {
        item.showAdditional = false;
        item.selectedNestedObj = [];  
        item?.nestedObj?.forEach(nestedData => {
          this.additionalOptional = this.additionalOptional.filter(data => data.name !== nestedData.name)
          nestedData.selected = false;
        })
      }
    });
    this.selectedCapability = this.optionalCapabilities?.filter(item => item?.selected === true);
  }

  selectExchangeAdapter(capability): void {
    this.exchangeAdapters.find(item => item?.name === capability?.name).selected = !capability.selected;
    this.exchangeAdapters?.forEach(item => {
      if(item?.name === capability?.name && item?.selected === true) {
        item.showAdditional = true;
      } else if(item?.name === capability?.name && item?.selected === false) {
        item.showAdditional = false;
        item.selectedNestedObj = [];
        item?.nestedObj?.forEach(nestedData => {
          this.additionalExchangeAdapters = this.additionalExchangeAdapters.filter(data => data.name !== nestedData.name)
          nestedData.selected = false;
        })
      }
    });
    this.selectedExchangeAdapters = this.exchangeAdapters?.filter(item => item?.selected === true);
  }

  // Opens confirmation dialog to cancel/leave current page
  goBack(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('CREATE_SERVICE.CANCEL_TITLE'),
        message: translate('CREATE_SERVICE.CANCEL_MESSAGE'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.SERVICE_DEFINITION]);
        }
      });
  }

  // Navigates to previous solution list page
  previous(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.SERVICE_DEFINITION, RouterSegments.SOLUTION]);
  }

  // Checks if a given capability is already selected
  isUpdated(capability): boolean {
    if (this.selectedCapabilities) {
      return this.selectedCapabilities.some(e => e.name === capability.name);
    }
  }

  selectionChanged(changedCapability: Capability): void {
    const selectedCapabilities = [];
    selectedCapabilities.push(changedCapability);
    setTimeout(() => {
      const action = changedCapability?.selected ? translate('TENANT_LAYOUT.SERVICE_DEFINITION.ADDED') : translate('TENANT_LAYOUT.SERVICE_DEFINITION.REMOVED');
      const message = `${changedCapability?.displayName} ${action}`;
      const title = translate('INSTANCE_SUMMARY.SERVICE_DEFINITION.SELECTED_CAPABILITIES');
      this.toastrService.successMessage(message, title);
    }, 500);

    if (!this.activatedRoute.snapshot.params.blueprintId) {
      this.UpdateExtendService = false;
      this.UpdateExtendServiceDisable = false;
    } else {
      this.UpdateExtendService = true;
      this.UpdateExtendServiceDisable = true;
    }

    selectedCapabilities.reduce(
      (acc, capability, c) => {
        if (capability.selected === true && capability.required === CapabilityType.OPTIONAL) {
          this.selectedCapabilitiesArr.push(capability);
        } else {
          this.selectedCapabilitiesArr
            .reduce((cap, falseCapability) => {
              if (falseCapability.selected === false) {
                this.selectedCapabilitiesArr = this.selectedCapabilitiesArr.filter((x) => {
                  if (x.selected === true && x.required === CapabilityType.OPTIONAL) {
                    return x.selected === true;
                  }
                });
              }
              return cap;
            }, {});
        }
        return acc;
      }, {}
    );
  }


  resetSelection(): void {
    this.optionalCapabilities?.map(item => { 
      item.selected = false;
      item.nestedObj?.forEach(element => {
        element.selected = false;
      });
      item.selectedNestedObj = [];
    });
    this.selectedCapability = [];
    this.additionalOptional = [];
  }

  resetExchangeSelection(): void {
    this.exchangeAdapters?.map(item => { 
      item.selected = false;
      item.nestedObj?.forEach(element => {
        element.selected = false;
      });
      item.selectedNestedObj = [];
    });
    this.selectedExchangeAdapters = [];
    this.additionalExchangeAdapters = [];
  }

  getSelectedCapabilities(): any[] {
    const selectedCapabilities = [];
    const selectedCapabilitiesByName = [];
    if (this.capabilities && this.capabilities.length > 0) {
      this.capabilities.filter((x) => {
        if (x.selected) {
          selectedCapabilities.push(x);
          selectedCapabilitiesByName.push(x.name);
        }
      });
    }
    localStorage.setItem('selectedCapabilities', JSON.stringify(selectedCapabilities));
    return selectedCapabilitiesByName;
  }

  createService(): void {
    if (this.includedCapabilities?.length === 0 && this.selectedCapability?.length === 0) {
      this.dialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    } else {
      this.selectedCapability = this.selectedCapability ? this.selectedCapability : [];
      this.includedCapabilities = this.includedCapabilities ? this.includedCapabilities : [];
      this.selectedExchangeAdapters = this.selectedExchangeAdapters ? this.selectedExchangeAdapters : [];
      const allSelectedCapabilities = [...this.includedCapabilities, ...this.selectedCapability, ...this.selectedExchangeAdapters];
      localStorage.setItem('selectedCapabilities', JSON.stringify(allSelectedCapabilities));
      localStorage.setItem('selectedVersion', JSON.stringify(this.selectedVersion));
      if(this.blueprintId) {
        this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.activatedRoute.snapshot.params.id, RouterSegments.SERVICE_DEFINITION, RouterSegments.SOLUTION, this.activatedRoute.snapshot.params.solutionId, this.service.latestSolutionVersionId, RouterSegments.DEFINITION, RouterSegments.EXTEND, this.activatedRoute.snapshot.params.blueprintId
        ], {state: {data: this.getSelectedCapabilities()}});
      } else {
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.SERVICE_DEFINITION, RouterSegments.SOLUTION, this.solution?.id, (this.sortedSolutionVersionId ? this.sortedSolutionVersionId[0]?.id : this.solution.latestSolutionVersionId), RouterSegments.DEFINITION]);
      }
    }
  }

  continue(): void {
    if (this.removeExchangeTab) {
      this.createService();
    } else {
      this.capabilitiesPage = false;
    }
  }

  previousCapabilityPage(): void {
    this.capabilitiesPage = true;
  }

  navigateToSolution(id): void {
    this.router.navigate(['/',this.authService.principal.provider, 'tenant', this.tenantId,RouterSegments.SOLUTION, id, 'versions']);
  }

  searchChanged(value): void {
    this.versionData = this.versionsList;
  }

  resetFilter(): void {
      this.solutionVersionForm.get('searchValue').reset();
      this.versionData = this.versionsList;
      if(this.versionData.length === 0) {
        const noRelease = 'Release not Available';
        this.versionData.push(noRelease);
     }
  }

  getSelectedVersion(event): void {
    this.selectedVersion = event;
    this.versionSelected = true;
    this.getLatestSolutionVersion(event.solutionId, event.id);
  }

  onOptionsSelected(data){
    this.versionData = this.versionsList.filter(item => item?.releaseVersion?.includes(data.value));
  }

  dropdownClose(): void {
    if (this.versionData?.length === 0) {
      this.versionData = this.versionsList;
    }
  }

  versionGroup(versions) {
    let group = [];
    this.versionsList = versions;
    this.versionsList.forEach(item => {
      group.push(item?.version?.split('.')[0]);
    });
    group = [...new Set(group)];

    let makeGrouping = [];
    group.forEach(groupItem => {
      const versions: any = this.versionsList.filter(item => item?.version?.split('.')[0] === groupItem);
      if (versions[0]?.releaseVersion) {
        const groupName = {version: groupItem, group: true, releaseVersion: (versions[0]?.releaseVersion.split('.')[0].split('').length > 2 ? versions[0]?.releaseVersion.split('.')[0] : 'R'+versions[0]?.releaseVersion.split('.')[0])};
        versions.push(groupName);      
        makeGrouping.push(versions);
      }
    });

    const combineData = makeGrouping.flat();
    const finalData = combineData.sort((a, b) => { 
      if (a.version < b.version) return -1;
      if (a.version > b.version) return 1;
    })

    this.versionsList = finalData;
    this.versionData = finalData;
  }

}
